document.addEventListener("DOMContentLoaded", initBottomBounce);

function initBottomBounce() {
  const boosters = document.querySelectorAll("footer .shopify-section:nth-child(2) .section-content-wrapper .group-block:nth-child(2) img");
  if (!boosters.length) return;

  const scroller = document.querySelector(".page-wrapper");
  if (!scroller) return;

  let wasAtBottom = false;

  scroller.addEventListener("scroll", () => {
    const scrollTop = scroller.scrollTop;
    const containerHeight = scroller.clientHeight;
    const contentHeight = scroller.scrollHeight;

    const atBottom = scrollTop + containerHeight >= contentHeight - 10;

    if (atBottom && !wasAtBottom) {
      boosters.forEach((booster, index) => {
        setTimeout(() => {
          booster.classList.remove("is-bouncing");
          void booster.offsetWidth;
          booster.classList.add("is-bouncing");
        }, index * 140);
      });
    } else if (!atBottom) {
      boosters.forEach((booster) => booster.classList.remove("is-bouncing"));
    }

    wasAtBottom = atBottom;
  });
}